import type { Dictionary } from '../types';

// Example second locale (Spanish) demonstrating the i18n scaffold — see
// `docs/I18N.md` for how to add more locales or translate additional content.
export const es: Dictionary = {
    'nav.home': 'Inicio',
    'nav.about': 'Sobre Nosotros',
    'nav.origins': 'Orígenes Globales',
    'nav.products': 'Productos',
    'nav.quality': 'Calidad',
    'nav.contact': 'Contáctenos',
    'language.label': 'Idioma',
};

export default es;
